import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import UserUpdateMenuItem from "@/v2-backoffice-client/user/update/UserUpdateMenuItem"
import UserCustomerUpdateSelectorDialogMenuItem from "@/v2-backoffice-client/user/customer/update/UserCustomerUpdateSelectorDialogMenuItem"
import UserResetPasswordMenuItem from "@/v2-backoffice-client/user/resetPassword/UserResetPasswordMenuItem"
import UserRevokeSessionsMenuItem from "@/v2-backoffice-client/user/revokeSessions/UserRevokeSessionsMenuItem"
import UserExternalToolMenuItems from "@/v2-backoffice-client/user/UserExternalToolMenuItems"
import UserStatusUpdateActions from "@/v2-backoffice-client/user/status/update/UserStatusUpdateActions"

export type CustomerUserTableRowToolbarProps = {
  user: UserFragment
}

function CustomerUserTableRowToolbar(props: CustomerUserTableRowToolbarProps) {
  const { user } = props

  return (
    <ActionMenu>
      <ActionMenu.Trigger />

      <ActionMenu.Content>
        <ActionMenu.Label>User Actions</ActionMenu.Label>

        <div className="pl-2">
          <UserExternalToolMenuItems user={user} />

          <ActionMenu.Separator />

          <UserUpdateMenuItem user={user} />
          <UserCustomerUpdateSelectorDialogMenuItem user={user} />

          <ActionMenu.Separator />

          <UserResetPasswordMenuItem userId={user.Id} />
          <UserRevokeSessionsMenuItem userId={user.Id} />
          <UserStatusUpdateActions
            userId={user.Id}
            currentStatusCode={user.UserStatusCode}
          />
        </div>
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default CustomerUserTableRowToolbar
